// extracted by mini-css-extract-plugin
export default {"hidden":"Form_hidden__IPWU8","placeHolderShimmer":"Form_placeHolderShimmer__QbPLo"};